import { getValidationMessage } from '@gef-ui/localization/messages';
import invariant from 'invariant';
import allPass from "ramda/es/allPass";
import compose from "ramda/es/compose";
import is from "ramda/es/is";
import isEmpty from "ramda/es/isEmpty";
import not from "ramda/es/not";
import toUpper from "ramda/es/toUpper";
import { VALID } from '../../constants';
const notEmptyString = allPass([
    is(String),
    compose(not, isEmpty)
]);
export default ((dispatch)=>({ validate, severity })=>({ field, ...otherParams })=>Promise.resolve().then(()=>{
                const validationPromise = dispatch(validate({
                    field,
                    ...otherParams
                }));
                invariant(is(Promise, validationPromise), `async validation function must return promise, check validations for '${field}'`);
                return validationPromise;
            }).then((messageKey)=>{
                const notEmptyMessage = notEmptyString(messageKey);
                return {
                    severity,
                    valid: notEmptyMessage ? toUpper(severity) : VALID,
                    errorMessage: notEmptyMessage ? getValidationMessage(messageKey, {
                        field,
                        messageKey
                    }) : undefined
                };
            }));
